export default __webpack_public_path__ + "static/media/we-are-the-champions.2405bf22.png";